import { Button } from "../../../components/ui/button";
import { Card, CardContent, CardTitle } from "../../../components/ui/card";

const Knowledgebase = () => {
  return (
    <div className="w-full flex items-center justify-center ">
      <Card className="max-w-xl overflow-hidden p-3 text-center">
        <CardTitle className="text-md mb-2 flex justify-center w-full items-center">
          Knowledgebase
        </CardTitle>

        <CardContent className="p-3 pt-2">
          <p>
            The AML/CTF Rules 2025 set out Australia’s regulatory framework to
            prevent money laundering and terrorism financing. They provide
            guidance on customer due diligence, reporting obligations, risk
            management, and compliance requirements for businesses under the
            AML/CTF Act.
          </p>
          <a
            href="https://www.austrac.gov.au/amlctf-reform/reforms-guidance/before-you-start/new-industries-and-services-be-regulated-reform/professional-services-reform"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button className="w-full mt-4">Learn More</Button>
          </a>
        </CardContent>
      </Card>
    </div>
  );
};

export default Knowledgebase;
